import script from "./noData.vue?vue&type=script&setup=true&lang=ts"
export * from "./noData.vue?vue&type=script&setup=true&lang=ts"

import "./noData.vue?vue&type=style&index=0&id=245fb317&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-245fb317"]])

export default __exports__